import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Orquestrador from './Components/Orquestrador';

function App() {
  useEffect(() => {
    document.title = 'Formulário de Filiação - União Brasileira de Compositores';
  }, []);
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Orquestrador tipo="pf" />} />
        <Route path="/pf" element={<Orquestrador tipo="pf" />} />
        <Route path="/pj" element={<Orquestrador tipo="pj" />} />
      </Routes>
    </Router>
  );
}

export default App;
